<div fxLayout="column" fxLayoutGap="10px">
	<h1 mat-dialog-title>Edit Document</h1>
	<rpshared-edit-document [formControl]="control"></rpshared-edit-document>
	<div mat-dialog-actions>
		<button mat-button mat-dialog-close color="warn">
			Cancel
		</button>
		<button
			mat-button
			[disabled]="group.invalid"
			color="primary"
			[mat-dialog-close]="group"
		>
			Save
		</button>
	</div>
</div>
